/** Cross-app UX copy (XAP-20, XAP-27, D-76). Product text is Persian. */

export const FILTER_CLEAR_ACTION_FA = 'پاک‌کردن فیلترها';

/** F-1 capacity change rule (short on screen, full on demand). */
export const CAPACITY_CHANGE_SHORT_FA = 'کاهش زیر مصرف فعلی مجاز است؛ ظرفیت آزاد صفر می‌شود.';

export const CAPACITY_CHANGE_FULL_FA =
  'تغییر سقف ظرفیت مصوب، از جمله ظرفیت اولیه، پس از تأیید یک مدیر دیگر اعمال می‌شود مگر مدیر مستقیم باشید. کاهش سقف زیر ظرفیت مصرف‌شدهٔ فعلی مجاز است و ظرفیت آزاد را صفر می‌کند. افزایش سقف تعهد فروشگاه را بالا می‌برد.';

/** F-2 payout hold after account change (short on screen, full on demand). */
export const PAYOUT_HOLD_SHORT_FA = 'پس از تغییر حساب، تسویه یک هفته به‌تعویق می‌افتد.';

export const PAYOUT_HOLD_FULL_FA =
  'پس از تأیید حساب تسویهٔ جدید، پرداخت تسویهٔ فروشگاه تا پایان هفتهٔ قراردادی بعدی نگه داشته می‌شود و به آن هفته منتقل می‌شود. تعهد SAAY به فروشگاه بدون تغییر می‌ماند.';

/** Guarantee policy revision (D-20). */
export const GUARANTEE_POLICY_SHORT_FA = 'سقف و تعداد جدید فقط برای ضمانت‌های بعدی است.';

export const GUARANTEE_POLICY_FULL_FA =
  'سقف و تعداد جدید فقط برای کدهای معرف و روابط ضمانت بعدی اعمال می‌شود؛ روابط و تعهدات ضمانت موجود تغییر نمی‌کنند.';
